import { Cloudinary, Transformation } from 'cloudinary-core';
import * as React from 'react';

interface ICloudinaryImageProps
  extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  path: string;
  cloudName: string;
  options?: Transformation.Options;
}

export function CloudinaryImage(props: ICloudinaryImageProps) {
  const { cloudName, path, options, ...imageProps } = props;

  const cl = Cloudinary.new({ cloud_name: cloudName });

  const defaultOptions: Transformation.Options = {
    crop: 'scale',
    dpr: 'auto',
    fetchFormat: 'auto',
    quality: 'auto',
    responsive: true,
    secure: true,
    width: 'auto',
  };

  const cloudinaryOptions = { ...defaultOptions, ...options };
  const url = cl.url(path, cloudinaryOptions);

  return <img {...imageProps} src={url} />;
}

export default CloudinaryImage;
